import { ITravelHotelSearchResult } from '@shared/shared/interfaces/travel-hotel.interfaces';
import * as fromActions from '../actions/hotel-details.actions';

export const initialState: ITravelHotelSearchResult = {
  id: '',
  title: '',
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postcode: '',
    country: '',
    formatted_address: '',
    location: {
      longitude: 0,
      latitude: 0,
    },
  },
  contact_details: {
    phone_number: '',
  },
  benefit_descriptions: [],
  description: '',
  star_rating: 0,
  amenities: '',
  images: [],
};

export function reducer(state = initialState, action: fromActions.HotelDetailsActions): ITravelHotelSearchResult {
  switch (action.type) {
    case fromActions.GET_HOTEL_DETAIL_SUCCESS:
    case fromActions.RESTORE_HOTEL_DETAIL_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case fromActions.CLEAR_HOTEL_DETAILS:
      return initialState;
    default:
      return state;
  }
}
